import { storage } from "components/common";

const USERS_CONFIG_STORAGE_KEY = "usersConfig";
const USERS_CONFIG_STORAGE_DEFAULT_VALUE = JSON.stringify({});

const [_fetchUsersConfig, _storeUsersConfig] = storage(USERS_CONFIG_STORAGE_KEY, {
  defaultValue: USERS_CONFIG_STORAGE_DEFAULT_VALUE,
});

const fetchUsersConfig = () => JSON.parse(_fetchUsersConfig());

const storeUsersConfig = usersConfig => _storeUsersConfig(JSON.stringify(usersConfig));
const storeUserConfigField = (username, field, value) => {
  const usersConfig = fetchUsersConfig();

  storeUsersConfig({
    ...usersConfig,
    [username]: {
      ...usersConfig[username],
      [field]: value,
    },
  });
};

export const getCustomerId = username => fetchUsersConfig()[username]?.customerId;
export const storeCustomerId = (username, customerId) => storeUserConfigField(username, "customerId", customerId);